module.exports = __webpack_public_path__ + "img/7_13.b29a3edb.png";